export const getNotificationMessage = (message: string) =>
  `${message}${isReportNotification(message) ? ". Click to download." : ""}`;

export const isReportNotification = (message: string) =>
  message.includes("Your report is ready");
